export default "__VITE_ASSET__9c91f7b1__"